import { FC } from 'react';

import { IconProps } from '../types';

export const PaperCancelIcon: FC<IconProps> = ({
	size,
	height = 24,
	width = 24,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 24 24"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M4 23h14c1.654 0 3-1.35 3-3V7.5c0-.26-.105-.52-.293-.71l-5.5-5.5A1.027 1.027 0 0 0 14.5 1H6C4.346 1 3 2.35 3 4v4c0 .55.448 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h7v5c0 .55.447 1 1 1h5v11c0 .55-.448 1-1 1H4c-.552 0-1 .45-1 1s.448 1 1 1ZM18.086 7 15 3.91V7h3.086Z"
		/>
		<path
			fill={color}
			fillRule="evenodd"
			d="M8 18.5c-.256 0-.512-.1-.707-.29L5.5 16.41l-1.793 1.8c-.195.19-.45.29-.707.29-.256 0-.512-.1-.707-.29a1.006 1.006 0 0 1 0-1.42L4.086 15l-1.793-1.79a1.006 1.006 0 0 1 0-1.42 1 1 0 0 1 1.414 0l1.793 1.8 1.793-1.8a1 1 0 0 1 1.414 0c.391.39.391 1.03 0 1.42L6.914 15l1.793 1.79c.391.39.391 1.03 0 1.42-.195.19-.45.29-.707.29Z"
		/>
	</svg>
);
